import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import DefaultMessage, { DefaultMessageProps } from './DefaultMessage';

type SessionCountdownMessageProps = DefaultMessageProps & {
  callback: () => void;
};

const SessionCountdownMessage = ({
  callback,
  ...props
}: SessionCountdownMessageProps) => {
  const [countDown, setCountDown] = useState(30);
  const timerRef = useRef(0);
  useEffect(() => {
    timerRef.current = setInterval(() => {
      setCountDown(dCountDown => dCountDown - 1);
    }, 1000);
  }, []);
  useEffect(() => {
    if (countDown === 0) {
      clearInterval(timerRef.current);
      callback();
    }
  }, [countDown, callback]);
  return (
    <DefaultMessage
      {...props}
      message={`Due to inactivity, you will be logged out of your account in ${countDown} second(s)`}
    />
  );
};

SessionCountdownMessage.propTypes = {
  callback: PropTypes.func.isRequired
};

export default SessionCountdownMessage;
